// extracted by mini-css-extract-plugin
export var marginNegative = "_6z-5 _6z-3 _6z-1";
export var marginPositive = "_6z-4 _6z-3 _6z-1";
export var modalContent = "_6z-6";
export var samplesTable = "_6z-8";
export var samplesTableContainer = "_6z-7";
export var statBox = "_6z-a";
export var tableCell = "_6z-1";
export var tableCellCenter = "_6z-2 _6z-1";
export var tableCellRight = "_6z-3 _6z-1";
export var tableHeader = "_6z-0";
export var trackingNumber = "_6z-9";